import { render, staticRenderFns } from "./ProductoTiendaMiniTableComponent.vue?vue&type=template&id=3afca314&"
import script from "./ProductoTiendaMiniTableComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoTiendaMiniTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports